import axios from "axios";
import {
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_HISTORY_FAILURE,
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
    UPDATE_AWB_REQUEST,
  UPDATE_AWB_SUCCESS,
  UPDATE_AWB_FAILURE,
} from "./ActionType";
import api, { API_BASE_URL } from "../../../config/api";

export const createOrder = (reqData) => async (dispatch) => {
  console.log("create order req ", reqData);
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    console.log("create order req ", reqData)
    console.log("create order req ", reqData)
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${reqData.jwt}`,
      },
    };

    const { data } = await axios.post(
      `${API_BASE_URL}/api/orders/`,
      reqData.addressId ? { _id: reqData.addressId } : reqData.address,
      config)

    // const { data } = await api.post(
    //   `/api/orders/`,
    //   reqData.addressId ? { _id: reqData.addressId } : reqData.address,
    //   config
    // );

    if (data._id) {
      reqData.navigate({ search: `step=3&order_id=${data._id}` });
    }
    console.log("created order - ", data);
    dispatch({
      type: CREATE_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log("catch error : ", error);
    dispatch({
      type: CREATE_ORDER_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


export const updateAwbNumber = (orderId, awbNo, awbPrint , jwt) => async (dispatch) => {
  dispatch({ type: UPDATE_AWB_REQUEST });

  try {
    const config = {
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(
      `${API_BASE_URL}/api/orders/${orderId}/awb`,
      { awbNo , awbPrint},
      config
    );

    dispatch({
      type: UPDATE_AWB_SUCCESS,
      payload: data.order, // Assuming backend returns updated order inside `order`
    });
  } catch (error) {
    dispatch({
      type: UPDATE_AWB_FAILURE,
      payload: error.response?.data?.error || error.message,
    });
  }
};

export const getOrderById = (orderId) => async (dispatch) => {
  // console.log("get order req ", orderId);
  try {
    let token = localStorage.getItem("jwt");
    dispatch({ type: GET_ORDER_BY_ID_REQUEST });
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    const { data } = await api.get(
      `/api/orders/${orderId}`,
      config
    );
    dispatch({
      type: GET_ORDER_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log("catch ", error)
    dispatch({
      type: GET_ORDER_BY_ID_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getOrderHistory = (reqData) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ORDER_HISTORY_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${reqData.jwt}`,
      },
    };

    const { data } = await api.get(`/api/orders/user`);
    dispatch({
      type: GET_ORDER_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ORDER_HISTORY_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
